var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tour',{attrs:{"callbacks":_vm.callbacks,"name":_vm.name,"steps":_vm.steps},scopedSlots:_vm._u([{key:"default",fn:function(tour){return [_c('TourContainer',{attrs:{"name":_vm.name,"tour":tour}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }